import React from "react"
import NewLayout from "../layout/newLayout"
import SEO from "../components/seo"
import cn from "classnames"
import styles from "../styles/scss/templates/sema.module.scss"
import HeroSema from "../components/heroSema2023"

const Sema2023 = ({ ...props }) => {
    // Context/Data of the Page
    const pageData = props.pageContext.page
    // End of Context/Data

    const { heroDesktop, heroMobile, seo } = pageData
    const pageTitle = seo.description

    return (
        <NewLayout>
            <SEO page={pageData} />

            <div className={cn(styles.semaWrapper, styles.semaWrapper2023, styles.fadeIn)}>
                {heroDesktop ? (
                    <HeroSema
                        images={[heroMobile, heroDesktop]}
                        title={pageTitle}
                        goTo={"gallery"}
                    />
                ) : (
                    false
                )}
            </div>
        </NewLayout>
    )
}

export default Sema2023
